import React, {useEffect, useState} from "react";
import images from "components/UI/images";
import icons from "components/UI/icons/icons";
import socials from "components/UI/icons/socials";
import {INominee, NomineeIdType} from "API/types";
import {Link, useLocation} from "react-router-dom";

interface ICardProps extends INominee {
    makeVote: (id: NomineeIdType) => Promise<void | true>;
    connectWallet: () => Promise<void | true>;
}

const Card: React.FC<ICardProps> = (
    {
        makeVote,
        connectWallet,
        id,
        description,
        name,
        count_vote,
        is_vote,
        participantInfo,
        socialMediaInfo,
        introductionInfo
    }
) => {
    const {IconColorFacebook, IconColorInstagram, IconColorTiktok, IconColorTwitter, IconColorYoutube} = socials;
    const [isVoted, setIsVoted] = useState<boolean>(is_vote);
    const [countVote, setCountVote] = useState<number>(count_vote);
    const {ImageVideoPreview} = images;
    const {IconLike, IconPlay} = icons;
    let location = useLocation();

    useEffect(() => {
        setIsVoted(is_vote);
    }, [is_vote]);

    const handleClick = async () => {
        const response = await makeVote(id);

        if (response) {
            setIsVoted(!isVoted);

            if (!isVoted) {
                setCountVote(countVote + 1);
            } else {
                setCountVote(countVote - 1);
            }
        } else {
            connectWallet();
        }
    };

    const getYouTubeIdFromUrl = (url: string) => {
        if (typeof url !== "string") {
            /* @ts-ignore */
            url = socialMediaInfo['YT full vid (Ira)']
        }
        let regExp =
          /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        let match = url.match(regExp);
        return match && match[7].length == 11 ? match[7] : false;
    };

    const getUrlFromString = (string: string) => {
      return string.split(' ')[1];
    }

    const detectSocialMediaByUrl = (url : string) => {
        if (url.includes('instagram')) {
          return <IconColorInstagram/>;
        } else if (url.includes('tiktok')) {
          return <IconColorTiktok />;
        } else if (url.includes('fb')) {
          return <IconColorFacebook />;
        } else if (url.includes('facebook')) {
          return <IconColorFacebook />;
        } else if (url.includes('youtu')) {
          return <IconColorYoutube />;
        } else if (url.includes('twitter')) {
          return <IconColorTwitter />;
        } else {
          return 'Unknown';
        }
      }

        const capitalizeFirstLetter = (string: string) => {
            return string.length === 2 ? string.toUpperCase() : string.charAt(0).toUpperCase() + string.slice(1);
        }
      
        console.log('participantInfo', participantInfo)
        /* @ts-ignore */
        // let title = typeof participantInfo.topInfo !== 'undefined' ? `${participantInfo.topInfo} \n ` : '';

        /* @ts-ignore */
        let title = typeof participantInfo.Title !== 'undefined' ? participantInfo.Title : `${capitalizeFirstLetter(participantInfo.Type)}: ${participantInfo.Name}`;

        /* @ts-ignore */
        let cardClass = count_vote > 0 ? `card__${participantInfo.Type}` : `card__gray card__gray__${participantInfo.Type}`;        

        cardClass = cardClass.toLowerCase()
      
    
    return (
        <div className={`card ${cardClass}`}>
            <div className="card__top video-container">
                {/* @ts-ignore */}
                <iframe src={`https://www.youtube.com/embed/${getYouTubeIdFromUrl(participantInfo.YT)}`} title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" frameBorder={0} ></iframe>
            </div>

            <div className="card__bottom">
                {/* @ts-ignore */}
                {typeof participantInfo.topInfo !== 'undefined' ? <p className="h2 card__name"><div dangerouslySetInnerHTML={{__html: participantInfo.topInfo}}></div>{title}</p> : <p className="h2 card__name">{title}</p>
                }
                
                
                    {count_vote > 0 &&
                        <Link state={{backgroundLocation: location}} to={`view-votes/${id}`}
                        className="card__count-votes decor-text">{countVote} votes</Link> 
                    }
                
                
                      {/* @ts-ignore */}
                <p className="card__description">{participantInfo.Description}</p>
                <br/>
                                <p className="card__social-media-title"> Main Video: </p>
                                <ul className="social-networks">
                                    <li>
                                        {/* @ts-ignore */}
                                        <a target="_blank" rel="noreferrer" href={socialMediaInfo['IG (Ramiz)']}>
                                            <IconColorInstagram />
                                        </a>
                                    </li>
                                    <li>
                                        {/* @ts-ignore */}
                                        <a  target="_blank" rel="noreferrer" href={socialMediaInfo['TT (Alisa)']}>
                                            <IconColorTiktok />
                                        </a>
                                    </li>
                                    <li>
                                        {/* @ts-ignore */}
                                        <a target="_blank" rel="noreferrer" href={socialMediaInfo['FB (Ira Erika)']}>
                                            <IconColorFacebook />
                                        </a>
                                    </li>
                                    <li>
                                        {/* @ts-ignore */}
                                        <a target="_blank" rel="noreferrer" href={socialMediaInfo['TW (Ramiz)']}>
                                            <IconColorTwitter />
                                        </a>
                                    </li>
                                    <li>
                                        {/* @ts-ignore */}
                                        <a target="_blank" rel="noreferrer" href={socialMediaInfo['YT full vid (Ira)']}>
                                            <IconColorYoutube />
                                        </a>
                                    </li>
                                </ul>
                                <br />
                                
                                {introductionInfo.length !== 0 ? 
                                    <>
                                    <p className="card__description">Introduction Video: </p>
                                    <ul className="social-networks social-networks--introduction">
                                        { 
                                            introductionInfo.map((item: string) =>
                                            <li key={item} className="vote__item">
                                                <a target="_blank" rel="noreferrer" href={getUrlFromString(item)}>
                                                    {detectSocialMediaByUrl(item)}
                                                </a>
                                            </li>
                                        )}
                                    </ul></> : ''
                                }
                {/* <button onClick={handleClick}
                        className={`card__vote-btn button decor-text ${isVoted ? "button--fulled card__vote-btn--liked" : ""}`}>
                    {
                        isVoted ? "Voted" : "Vote"
                    }
                    {
                        isVoted ? null : <span className="card__vote-icon" aria-label="vote heart icon">
                            <IconLike/>
                        </span>
                    }
                </button> */}
            </div>
        </div>
    );
};

export default Card;